'use client'

import Link from 'next/link'
import { TrackingEvents } from '../../lib/analytics'

const BASE_LINK_CLASS = 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-water-blue focus-visible:ring-offset-3'

export function TrackedToolLink({
  href,
  tool,
  placement,
  intent,
  pagePath,
  className = '',
  children,
  onClick,
  ...linkProps
}) {
  function handleClick(event) {
    TrackingEvents.trackDiagnosticToolEntry({
      tool,
      placement,
      intent,
      pagePath,
    })
    onClick?.(event)
  }

  return (
    <Link
      {...linkProps}
      href={href}
      onClick={handleClick}
      data-diagnostic-tool={tool}
      data-diagnostic-placement={placement}
      className={`${BASE_LINK_CLASS} ${className}`}
    >
      {children}
    </Link>
  )
}

function ActionLink({ action, placement, intent, pagePath, className }) {
  const content = (
    <>
      <span>{action.label}</span>
      <span aria-hidden="true">→</span>
    </>
  )

  if (action.tool) {
    return (
      <TrackedToolLink
        href={action.href}
        tool={action.tool}
        placement={placement}
        intent={intent}
        pagePath={pagePath}
        className={className}
      >
        {content}
      </TrackedToolLink>
    )
  }

  return (
    <Link href={action.href} className={`${BASE_LINK_CLASS} ${className}`}>
      {content}
    </Link>
  )
}

export function ContextualToolEntry({
  primaryAction,
  secondaryAction,
  placement,
  intent,
  pagePath,
}) {
  return (
    <div className="flex w-full flex-col gap-3 sm:w-auto sm:flex-row sm:flex-wrap sm:items-center">
      <ActionLink
        action={primaryAction}
        placement={placement}
        intent={intent}
        pagePath={pagePath}
        className="inline-flex min-h-11 items-center justify-center gap-2 rounded-[0.75rem] bg-water-ink px-5 py-3 text-center text-sm font-semibold text-white transition-colors hover:bg-water-blue-dark"
      />
      {secondaryAction ? (
        <ActionLink
          action={secondaryAction}
          placement={placement}
          intent={intent}
          pagePath={pagePath}
          className="inline-flex min-h-11 items-center justify-center gap-2 rounded-[0.75rem] border border-water-border bg-white px-5 py-3 text-center text-sm font-semibold text-water-ink transition-[background-color,border-color,color] hover:border-water-blue/40 hover:bg-water-aqua hover:text-water-blue-dark"
        />
      ) : null}
    </div>
  )
}
